import React, { useEffect } from "react"
import payIcon from "../imgs/payroll.png"
import referIcon from "../imgs/refer.png"
import faqIcon from "../imgs/payroll_faq.png"
import {Link} from "react-router-dom";
import { IonPage, IonHeader, IonToolbar, IonContent, IonFooter, createGesture } from "@ionic/react"
import Nav from "./Nav"
import Toolbar from "./Toolbar"
import { sidnavStore, SidenavState } from "../api/SidenavStore"

const Money = () => {

    const {open, close}: { open: boolean, close: () => void } = sidnavStore((state: SidenavState) => ({open: state.open, close: state.close}));
    const {toggleSidenav}: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({toggleSidenav: state.toggle}));

    const ref = React.useRef<HTMLInputElement>(null)

    useEffect(() => {
        gestureInit();
    }, [])

    const gestureInit = () => {
        const card = ref.current
        if (card) {
            const gesture = createGesture({
                el: card,
                gestureName: 'swipeMenu',
                onMove: (detail) => {
                    console.log("moving");
                },
                onEnd: (detail) => {
                    console.log("move ended");
                    toggleSidenav();
                }                 
            })
            gesture.enable();
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <Toolbar pageName="Docs"/>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen color="light">
                <div ref={ref} onClick={() => close()} style={{height: "80vh"}}>
                    <div className="item-container">
                        <div className="grid50">
                        <Link to="/settlements" className="western-button-link">
                                <div className="loading-div" id="centered">
                                    <p style={{margin: "15% 0 0%"}}>Settlements</p>
                                    <img src={payIcon} alt="key" className="link-icon"/>
                                </div>
                            </Link>
                            <div>
                                <Link to="/deferment" className="western-button-link">
                                    <div>
                                        <img src={referIcon} alt="key" className="link-icon"/><p>Deferment</p>
                                    </div>
                                </Link>
                                <Link to="/fuelreceipts" className="western-button-link">
                                    <div>
                                        <img src={faqIcon} alt="key" className="link-icon"/><p>Fuel Receipts<br/><span style={{fontSize: "12px"}}>Upload Photos</span></p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <Link className="western-button-link" to="/payrollfaq">
                            <div>
                                <img alt="key" className="link-icon" src={faqIcon} /><p>Settlements FAQ</p>
                            </div>
                        </Link>
                    </div>
                    </div>
            </IonContent>
            <IonFooter>
                <Nav pageName="Docs" onSearch={function (target: boolean): void {
                        console.log("Not ready");
                    } }/>
            </IonFooter>
        </IonPage>
    )
}

export default Money
